import { render, staticRenderFns } from "./CartaoPagamento.vue?vue&type=template&id=506bd87c&scoped=true"
import script from "./CartaoPagamento.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoPagamento.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CartaoPagamento.vue?vue&type=style&index=0&id=506bd87c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506bd87c",
  null
  
)

export default component.exports